import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import ReactTooltip from "react-tooltip";
import MCard from "components/Shared/MCard.tsx";
import MenuItem from "components/Notifications/MenuItem";

class Menu extends React.Component {

    constructor(props) {
        super(props);
        this.rebuildTooltip = this.rebuildTooltip.bind(this);
        this.getItems = this.getItems.bind(this);
        this.state = {
            key: false,
        };
    }

    componentDidMount() {
        window.addEventListener("resize", this.rebuildTooltip);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.rebuildTooltip);
    }

    rebuildTooltip() {
        const {key} = this.state;
        this.setState({
            key: !key,
        });
    }

    getItems() {
        const {items} = this.props;
        if(!items || !items.length)
            return [{
                key: "no-value",
                control:
                    <MenuItem emptyListItem/>
            }];
        return items;
    }

    render() {
        const {key} = this.state;
        const {place, className, setMenuRef, title} = this.props;
        return (
            <ReactTooltip
                key={key}
                id={tooltipId}
                data-tip
                data-for={tooltipId}
                ref={setMenuRef}
                isCapture={true}
                event={"click"}
                effect={"solid"}
                place={place}
                border={false}
                className={className + " mcard-tooltip"}
            >
                <MCard
                    title={title}
                    fields={this.getItems()}
                />
            </ReactTooltip>
        );
    }
}

Menu.defaultProps = {
    place: "bottom",
    title: "Placeholder",
};

Menu.propTypes = {
    //pure props
    place: PropTypes.string,
    title: PropTypes.string,
    items: PropTypes.array,
    isOpen: PropTypes.bool,
    setMenuRef: PropTypes.object,

    //HOC prop
    children: PropTypes.node,

    //styled-components prop
    className: PropTypes.string,
};

const StyledMenu = styled(Menu)`
    padding: 0;
    z-index: 1000;
    &:after {
        border-bottom-color: #c8102e !important;
    }
    & > .mcard {
        transform: translateX(calc(-50% + 10px)) translateZ(0);
        .md-card-text {
            padding: 0px !important;
        }
        .md-table-row {
            .md-table-column {
                padding: 0px;
            }
        }
    }
`;

StyledMenu.defaultProps = {
    isOpen: false,
};

StyledMenu.propTypes = {
    isOpen: PropTypes.bool,
};

export default StyledMenu;
export const tooltipId = "notifications-tooltip";
